<template>
    <div
        :class="['key-highlights', theme ? `key-highlights--theme-${theme}`: '']"
        v-if="data.items && data.items.length"
    >
        <div
            v-if="data.image && theme === 'background'"
            class="key-highlights__background"
            :style="`background-image: url(${data.image})`"
        ></div>
        <div class="key-highlights__body">
            <h2
                class="key-highlights__title"
                v-html="data.title"
                v-if="data.title"
            ></h2>
            <div class="key-highlights__container">
                <div class="row">
                    <div
                        :class="gridClass"
                        v-for="(item, index) in data.items"
                        :key="index"
                    >
                        <z-key-indicator
                            :value="item.value"
                            :value-text="item.sign"
                            :caption="item.text"
                        ></z-key-indicator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'key-highlights',
    props: {
        component: {
            type: String,
            default: 'key-highlights'
        },
        inlineData: {
            type: Object,
            default: () => {}
        },
        theme: String,
        gridClass: {
            type: String,
            default: 'col-default-4 col-v-tablet-6 col-mobile-12'
        }
    },
    computed: {
        data () {
            const component = this.$root.app.components[this.component] ? this.$root.app.components[this.component] : {}
            return this.inlineData ? this.inlineData : component
        }
    }
}
</script>

<style lang="scss">
    .key-highlights {
        $parent: &;

        position: relative;
        margin-bottom: $token-spacers-xxxl;

        &__title {
            margin-top: 0;
            margin-bottom: $token-spacers-xxl;
        }

        &__background {
            width: 100%;
            height: 100%;
            position: absolute;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            background-color: #FBB92F;

            &:before {
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                background-image: linear-gradient(90.18deg, #FAB82E 30.58%, rgba(250, 184, 46, 0.6) 99.85%);
                z-index: 0;
            }
        }

        &--theme {
            &-background {
                #{$parent}__title {
                    font-size: 48px;
                    color: $token-colors-white;
                    margin-top: 0;
                    margin-bottom: $token-spacers-xxl;

                    @include breakpoint (tablet) {
                        font-size: 28px;
                    }
                }

                #{$parent}__body {
                    position: relative;
                    padding: $token-spacers-l;
                }

                .z-key-indicator {
                    width: 100%;
                    height: 100%;

                    &__name {
                        min-height: 44px;
                        margin-bottom: 3px;

                        @include breakpoint (mobile) {
                            min-height: 0;
                        }
                    }

                    &__group {
                        flex-direction: column-reverse;
                        flex-wrap: nowrap;
                        justify-content: space-between;
                        height: 100%;
                    }

                    &__container {
                        flex-basis: auto;
                    }

                    &__caption {
                        color: $token-colors-white;
                        margin-top: 0;
                        margin-bottom: $token-spacers-s;
                    }

                    &__value {
                        color: $token-colors-white;

                        &-text{
                            font-size: 24px;
                            color: $token-colors-white;
                        }
                    }
                }
            }
        }
    }
</style>
